import { render, staticRenderFns } from "./userMpopup.vue?vue&type=template&id=0874600b"
import script from "./userMpopup.vue?vue&type=script&lang=js"
export * from "./userMpopup.vue?vue&type=script&lang=js"
import style0 from "./userMpopup.vue?vue&type=style&index=0&id=0874600b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports